import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { useFocusTrap } from "./useFocusTrap.js";
import "./Modal.css";
const BREITE_KLASSE = {
    standard: "",
    mittel: " ki-modal--mittel",
    breit: " ki-modal--breit",
    weit: " ki-modal--weit",
};
export function Modal(p) {
    const rahmen = useRef(null);
    /*
     * Die Arbeitsteilung am Riegel, damit sie nicht geraten werden muss:
     *
     *  - **Der RAHMEN hält die Taste.** Escape kommt hier an, und hier wird sie gesperrt —
     *    unabhängig davon, was der Rückruf des Aufrufers tut. Das ist der Grund, warum jede
     *    Maske `abbrechenGesperrt` AUCH an den Rahmen gibt und nicht nur an die Fußleiste:
     *    Ein Riegel allein am Knopf liesse die Tastatur daran vorbei (Fixrunde 1, 05.09.2026).
     *  - **Die FUSSLEISTE hält den Knopf** (`ModalFuss`, dieselbe Angabe): Ein gesperrter
     *    Knopf löst gar nicht erst aus.
     *  - **Der Aufrufer hält seinen eigenen Weg.** Die `abbrechen()`-Funktionen prüfen den
     *    Arbeitszustand weiterhin selbst — nicht als Doppelung derselben Stelle, sondern für
     *    die dritte Sorte Aufrufer: einen Knopf IM Panelinhalt („Anderen Kunden wählen"), den
     *    weder Rahmen noch Fußleiste kennen.
     *
     * Kurz: Jeder der drei Wege hinaus sperrt sich selbst. Wer einen vierten dazustellt,
     * sperrt ihn ebenfalls.
     */
    useFocusTrap(true, rahmen, () => {
        if (p.abbrechenGesperrt === true)
            return;
        p.onAbbrechen();
    });
    return (
    /*
     * `role="presentation"` und kein onClick: Der Hintergrund sperrt nur den Blick auf das
     * Dahinterliegende, er ist keine Schaltfläche.
     *
     * `preventDefault` auf dem eigenen Mausdruck hält den FOKUS im Panel. Ohne die Zeile
     * setzte ein Klick daneben den Fokus auf `document.body` — das Panel bliebe zwar stehen
     * (es schliesst ja nicht mehr), aber Escape käme danach nicht mehr an, weil der
     * Fokus-Baustein am Rahmen lauscht. Der Klick daneben würde damit die Tastatur
     * aussperren: schlimmer als das Schliessen, das er früher auslöste.
     *
     * Die Bedingung `target === currentTarget` ist wesentlich: Ein Mausdruck IM Panel
     * blubbert hier vorbei, und ihn zu unterbinden hiesse, dass kein Feld mehr den Fokus
     * bekäme.
     */
    _jsx("div", { className: "ki-modal__hintergrund", role: "presentation", onMouseDown: (e) => { if (e.target === e.currentTarget)
            e.preventDefault(); }, children: _jsxs("div", { ref: rahmen, tabIndex: -1, className: `ki-modal${BREITE_KLASSE[p.breite ?? "standard"]}`, role: "dialog", "aria-modal": "true", "aria-label": p.titel, children: [_jsx("h4", { className: "ki-modal__titel", children: p.titel }), p.children] }) }));
}
/**
 * Die Fußleiste eines strikten Modals — Speichern links, Abbrechen rechts, in jeder Maske
 * dieselbe Reihenfolge und dieselben Wörter.
 *
 * Sie steht hier und nicht in jeder Maske abgeschrieben, weil sie die Hausregel TRÄGT:
 * Solange jede Maske ihre zwei Knöpfe selbst zeichnete, konnte eine davon ein drittes
 * „Schliessen" dazustellen.
 */
export function ModalFuss(p) {
    return (_jsxs("div", { className: "ki-modal__aktionen", children: [_jsx("button", { type: "button", className: "ki-modal__primaer", disabled: p.speichernGesperrt === true, ...(p.speichernLabel === undefined ? {} : { "aria-label": p.speichernLabel }), onClick: p.onSpeichern, children: p.speichernText }), p.nurSchliessen !== true && (_jsx("button", { type: "button", className: "ki-modal__knopf", disabled: p.abbrechenGesperrt === true, onClick: p.onAbbrechen, children: "Abbrechen" }))] }));
}
/**
 * Die Rückfrage vor dem Abbrechen — der Hausweg (`window.confirm`), an einer Stelle.
 *
 * Liefert `true`, wenn wirklich abgebrochen werden darf: entweder weil nichts
 * Ungespeichertes darin steht, oder weil der Verlust bestätigt wurde. Derselbe Wortlaut wie
 * beim Verlassen-Wächter des Routers — es ist derselbe Verlust.
 */
export function darfAbbrechen(geaendert) {
    if (!geaendert)
        return true;
    return window.confirm("Hier stehen ungespeicherte Änderungen. Sie gehen verloren. Wirklich abbrechen?");
}
//# sourceMappingURL=Modal.js.map